import React, { useEffect, useMemo } from 'react'
import { useInstData, useEventHandler } from 'tyan/public/hooks'
import { hasChangedValues, getFormValue, changeItemsValue, getChangedFieldsets, getListIds } from 'tyan/public/utility'

const SpotPlanExecute = props => {
    const { setState, me } = useInstData(props, useMemo(() => ({
        state: {
            id: props.match.params.id || 0
        }
    }), []))

    const { showBody: Body } = props
    const { id } = me.state

    useEffect(() => {
        handleDidMount()
    }, [])

    const handleDidMount = () => {
        Tyan.doPostEvent('GetSpotPlanExecute', {
            data: { id },
            onEnd: ({ errorMessage, instrumentNumber, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    setState({ instrumentNumber, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    const handleSave = (finish = false) => {
        Tyan.doPostEvent({
            event: 'SaveSpotPlanExecute',
            data: { finish, ...getChangedFieldsets(me, '基本信息', false) },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    // window.history.back()
                    handlerBack()
                }
            }
        })
    }

    const handlerDelete = () => {
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DelSpotPlan',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('删除成功')
                        window.history.back()
                    }
                }
            })
        )
    }

    const handlerClose = () => {
        window.history.back()
        //onClose()
    }

    const handlerBack = () => {
        const { instrumentNumber } = me.state
        console.log('handlerBack', 'instrumentNumber', instrumentNumber)
        location.hash = `/QYWX/SpotCheckTask/${instrumentNumber}`
        // window.history.back()
        // //onClose()
    }

    const bChanged = () => {
        return hasChangedValues(me)
    }

    const bFinish = () => {
        let bOK = true
        const ids = getFormValue(me, '基本信息', '点检项目') || []
        for (var i = 0; i < ids.length; i++) {
            const list = { listName: '点检项目', id: ids[i] }
            bOK = getFormValue(me, '基本信息', '结果', list) && (getFormValue(me, '基本信息', '是否拍照', list) ? getFormValue(me, '基本信息', '点检照片', list).length > 0 : true)
            if (!bOK) break;
        }
        return bOK
    }

    const fieldset基本信息 = () => {
        const 点检项目 = getFormValue(me, '基本信息', '点检项目')
        return [
            { _text: '点检设备', disabled: true, minWidth: '95%', },
            {
                _group: '点检项目', minWidth: '95%', items: 点检项目 && 点检项目.map((id, index) => {
                    const fldCommProps = { required: true, minWidth: '95%', labelAlign: 'top', }
                    const list = { listName: '点检项目', id }
                    const 项目名称 = getFormValue(me, '基本信息', '项目名称', list)
                    const showName = `${index + 1}.${项目名称}`

                    var items = []
                    switch (getFormValue(me, '基本信息', '输入方式', list)) {
                        case '单选':
                            items.push({ _radio: showName, name: `结果`, items: getFormValue(me, '基本信息', '选项', list), itemMinWidth: 10, ...fldCommProps, })
                            break;
                        case '下拉选择':
                            items.push({ _select: showName, name: `结果`, options: getFormValue(me, '基本信息', '选项', list), itemMinWidth: 10, ...fldCommProps, })
                            break;
                        case '文本输入':
                            items.push({ _text: showName, name: `结果`, ...fldCommProps, })
                            break;
                        case '多行文本输入':
                            items.push({ _text: showName, name: `结果`, maxRows: 3, ...fldCommProps, })
                            break;
                    }
                    if (getFormValue(me, '基本信息', '是否拍照', list)) {
                        items.push({ _files: '点检照片', ...fldCommProps, })
                    }

                    return { _group: '', name: `${id}`, list, minWidth: '95%', margin: 0, items }
                })
            },
        ]
    }

    return <Body data={me}
        controls={
            [
                { _button: '完成', icon: '', handler: () => handleSave(true), disabled: !bFinish() },
                { _button: '保存', icon: '', handler: () => handleSave(false), disabled: !bChanged() },
                { _button: '删除', icon: '', ui: 'action decline alt', handler: handlerDelete, cdt: () => id > 0 && getFormValue(me, '基本信息', 'canDel') },
                { _button: bChanged() && '取消' || '关闭', icon: '', handler: handlerBack },
            ]
        }
        fieldsets={
            [
                { title: '', name: '基本信息', _fieldset: fieldset基本信息() },
            ]}
    />
}

export default SpotPlanExecute